import { LoggerLevel } from '@/constants/logLevel';
import { useLogger } from './useLogger';

export function useAppVersionCheck(): void {
  const versionUrl = '/version.json';
  const storageKey = 'app_version';
  const { log } = useLogger();

  window.addEventListener('focus', async () => {
    try {
      const res = await fetch(versionUrl, { cache: 'no-store' });
      const { version: latestVersion } = await res.json();

      const currentVersion = localStorage.getItem(storageKey);

      if (!currentVersion || currentVersion !== latestVersion) {
        log({
          message: 'New Version found, reloading',
          level: LoggerLevel.DEVELOPMENT,
          type: 'log'
        });
        localStorage.setItem(storageKey, latestVersion);
        window.location.reload();
      }
    } catch (err) {
      log({
        message: err as string,
        level: LoggerLevel.DEVELOPMENT,
        type: 'error'
      });
    }
  });
}
